import clsx from 'clsx';
import React, { ReactElement, useEffect, useState } from 'react';
import { Button, Text } from '@/components';
import ResponsiveText from '@/components/text/ResponsiveText';
import {
  makeElementClassNameFactory,
  makeRootClassName,
  StyleProps,
} from '@/utils';

export type PartnerContactProps = StyleProps;

const ROOT = makeRootClassName('PartnerContact');
const el = makeElementClassNameFactory(ROOT);

const DEFAULT_PROPS = {} as const;

function ContactPage(props: PartnerContactProps): ReactElement {
  const [end, setEnd] = useState(false);
  const p = { ...DEFAULT_PROPS, ...props };

  useEffect(() => {
    // If the user submits the form but wants to go back and submit again,
    // we need to reinitialize the form
    if (end) return;

    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/embed/v2.js';
    document.body.appendChild(script);

    script.addEventListener('load', () => {
      // @ts-expect-error Loading third party hubspot script
      window.hbspt?.forms?.create({
        region: 'na1',
        portalId: '22027487',
        formId: 'd91d24ea-1e23-4131-ac3b-a31ad77e4676',
        sfdcCampaignId: '701Rf000008YZZqIAO',
        target: '#hubspotForm',
        onFormSubmitted: function () {
          setEnd(true);
          return false;
        },
      });
    });
  }, [end]);

  return (
    <div className={clsx(ROOT, p.className)}>
      <div className={el`content`}>
        {end ? (
          <div className={el`end-screen`}>
            <ResponsiveText isHeavy>
              Thank you for contacting us!
            </ResponsiveText>
            <ResponsiveText isHeavy>
              We will respond to your message as soon as possible.
            </ResponsiveText>

            <Button
              variant="secondary"
              className="w-[120px]"
              onPress={() => setEnd(false)}
            >
              GOT IT
            </Button>
          </div>
        ) : (
          <div style={{ display: end ? 'none' : 'block' }}>
            <Text type="h4">
              Please reach out and we will get back to you shortly.
            </Text>
            <div id="hubspotForm" className="mt-[16px]" />
          </div>
        )}
      </div>
    </div>
  );
}

function ContactPageContainer(props: StyleProps): ReactElement {
  return <ContactPage {...props} />;
}

export default ContactPageContainer;
